export default __webpack_public_path__ + "media/Seafood-Shrimp.901cecca.png";